// extracted by mini-css-extract-plugin
export default {"card":"styles_card__dXdR+","icon":"styles_icon__XUfFB","inlineText":"styles_inlineText__hYA5l"};